// notifications.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_NOTIFICATIONS,
  REMOVE_NOTIFICATIONS,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Notifications.
 * @module reducer/notifications
 */
const notifications = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_NOTIFICATIONS:
      return _ADD_NOTIFICATIONS(action.payload)(state);
    case REMOVE_NOTIFICATIONS:
      return _REMOVE_NOTIFICATIONS(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Add notifications
 * @kind reducer/actionType
 * @name ADD_NOTIFICATIONS
 * @param {object} notifications - notifications
 * @return {Immutable.Map} New state
 */
const _ADD_NOTIFICATIONS =
  ({ notifications }) =>
  state => {
    return state.mergeDeep(notifications);
  };
/**
 * Remove notifications
 * @kind reducer/actionType
 * @name REMOVE_NOTIFICATIONS
 * @param {object} payload - payload
 * @return {Immutable.Map} New state
 */
const _REMOVE_NOTIFICATIONS =
  ({ itemIds = [] }) =>
  state => {
    return itemIds.reduce((acc, id) => acc.delete(id), state);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default notifications;
